import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Footershape from '../../../assets/images/shapes/site-footer-shape-1.png';
import footerLogo from '../../../assets/images/resources/site-footer-logo-1.png';
import { getEvents, getCategories } from '../../../services/eventService';

const formatDate = (iso) => {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleString('en-GB', {
      day: '2-digit', month: 'long', year: 'numeric', hour: 'numeric', minute: '2-digit',
    });
  } catch {
    return '';
  }
};

const Footer = () => {
  // আগে এখানে হার্ডকোড করা ২টা fake event ("Ui/ux Designer Meetup", তারিখ
  // 2024) দেখাত এবং "Get a Ticket" /event-details এ যেত — যেটা কোনো real
  // route-ই ছিল না (404)। এখন real, আসল upcoming event দেখায়, আর
  // সঠিক event page-এ (/events/:slug) নিয়ে যায়।
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  // আগে এই কলামে ৫টা fake category name ("Jubilee Events", "Gala Affairs"
  // ইত্যাদি) ছিল, যেগুলো database-এ আসলে নেই — এখন real category list
  // দেখানো হয়।
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    getCategories()
      .then((res) => setCategories((res.data || res || []).slice(0, 5)))
      .catch(() => setCategories([]));
  }, []);

  useEffect(() => {
    getEvents({})
      .then((res) => setUpcomingEvents((res.data || res || []).slice(0, 2)))
      .catch(() => setUpcomingEvents([]));
  }, []);

  return (
    <>
    {/* Site Footer Start */}
    <footer className="site-footer">
        <div className="site-footer__shape-1 float-bob-y">
            <img src={Footershape} alt="" />
        </div>
        <div className="site-footer__top">
            <div className="container">
                <div className="site-footer__top-inner">
                    <div className="site-footer__logo">
                        <Link to="/">
                            <img src={footerLogo} alt="" />
                        </Link>
                    </div>
                    <div className="site-footer__social">
                        <Link to="#"><i className="icon-facebook"></i></Link>
                        <Link to="#"><i className="icon-fi"></i></Link>
                        <Link to="#"><i className="icon-instagram"></i></Link>
                        <Link to="#"><i className="icon-pinterest"></i></Link>
                    </div>
                </div>
            </div>
        </div>
        <div className="site-footer__middle">
            <div className="container">
                <div className="site-footer__middle-inner">
                    <div className="row">
                        <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="100ms">
                            <div className="footer-widget__column footer-widget__events">
                                <div className="footer-widget__title-box">
                                    <h3 className="footer-widget__title">Upcoming Events</h3>
                                </div>
                                <ul className="footer-widget__events-list list-unstyled">
                                    {upcomingEvents.length > 0 ? (
                                        upcomingEvents.map((event) => (
                                            <li key={event.id}>
                                                <p>{formatDate(event.start_date)}{event.venue?.city ? ` — ${event.venue.city}` : ''}</p>
                                                <h5>{event.title}</h5>
                                                <Link to={`/events/${event.slug}`}>Get a Ticket <span className="icon-arrow-right"></span></Link>
                                            </li>
                                        ))
                                    ) : (
                                        <li>
                                            <p>&nbsp;</p>
                                            <h5>এই মুহূর্তে কোনো event নেই</h5>
                                            <Link to="/events">সব Event দেখুন <span className="icon-arrow-right"></span></Link>
                                        </li>
                                    )}
                                </ul>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="200ms">
                            <div className="footer-widget__column footer-widget__link">
                                <div className="footer-widget__title-box">
                                    <h3 className="footer-widget__title">Quick links</h3>
                                </div>
                                <ul className="footer-widget__link-list list-unstyled">
                                    <li><Link to="/about">About Us</Link></li>
                                    <li><Link to="/pricing">Pricing</Link></li>
                                    <li><Link to="/events">Buy Ticket</Link></li>
                                    <li><Link to="/blog-list">Blog Post</Link></li>
                                    <li><Link to="/contact">Contact Us</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="300ms">
                            <div className="footer-widget__column footer-widget__our-company">
                                <div className="footer-widget__title-box">
                                    <h3 className="footer-widget__title">Our Company</h3>
                                </div>
                                <ul className="footer-widget__link-list list-unstyled">
                                    {categories.length > 0 ? (
                                        categories.map((cat) => (
                                            <li key={cat.id}><Link to="/events" state={{ category: cat.slug }}>{cat.name}</Link></li>
                                        ))
                                    ) : (
                                        <li><Link to="/events">সব Event</Link></li>
                                    )}
                                </ul>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="400ms">
                            <div className="footer-widget__column footer-widget__contact">
                                <div className="footer-widget__title-box">
                                    <h3 className="footer-widget__title">Contact</h3>
                                </div>
                                <div className="footer-widget__contact-inner">
                                    <ul className="footer-widget__contact-list list-unstyled">
                                        <li>
                                            <div className="icon">
                                                <span className="icon-envelop"></span>
                                            </div>
                                            <div className="text">
                                                <p style={{ fontWeight: 600, marginBottom: 4 }}>MD Ridoy</p>
                                                <p><a href="mailto:redayh8888@gmail.com">redayh8888@gmail.com</a></p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="icon">
                                                <span className="icon-pin"></span>
                                            </div>
                                            <div className="text">
                                                <p>3891 Ranchview Dr. Richardson</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="icon">
                                                <span className="icon-call"></span>
                                            </div>
                                            <div className="text">
                                                <p><a href="tel:01245789321">01245789321, 012457895146</a></p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="site-footer__bottom">
            <div className="container">
                <div className="site-footer__bottom-inner">
                    <p className="site-footer__bottom-text">© EventFlow 2024 | All Rights Reserved</p>
                    <ul className="list-unstyled site-footer__bottom-menu">
                        <li><Link to="/about">Terms & Condition</Link></li>
                        <li><Link to="/about">Privacy Policy</Link></li>
                        <li><Link to="/contact">Contact Us</Link></li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
    {/* Site Footer End */}
    </>
  );
};

export default Footer;
